import { actionTypes } from './constants'

const initialState = {
  mode: '',
  filter: '',
  fetched: false,
  folders: undefined,
  items: undefined,
  expanded: undefined,
  selected: undefined,
  selectedsFolder: undefined,
  status: undefined,
  generatedReports: {},
  generatedReportsFetched: false,
  lastReportIdent: 0,
}

const reducer = (state = initialState, { type, payload, meta }) => {
  switch (type) {
    case actionTypes.INITIALIZE:
      return {
        ...state,
        folders: payload.folders,
        items: payload.items,
        expanded: payload.expanded,
        selected: payload.selected,
        selectedsFolder: payload.selectedsFolder,
        fetched: true,
      }

    case actionTypes.SET_PANEL_MODE:
      return {
        ...state,
        mode: payload.mode,
      }

    case actionTypes.GENERATED_REPORTS_FETCHED:
      return {
        ...state,
        generatedReports: { ...state.generatedReports, [meta]: payload },
        generatedReportsFetched: true,
      }

    case actionTypes.CHANGE_STATUS: {
      return {
        ...state,
        status: payload.status,
      }
    }

    case actionTypes.STORE_UPDATES: {
      return {
        ...state,
        expanded: payload.expanded,
        selected: payload.selected,
        selectedsFolder: payload.selectedsFolder,
        filter: payload.filter,
      }
    }

    case actionTypes.CHECK_REPORTS_STATUS: {
      return {
        ...state,
        lastReportIdent: payload.Data,
      }
    }

    case actionTypes.CLOSE:
      return initialState

    default:
      return state
  }
}

export default reducer
